var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('manage-fiscal-obligations-table',{attrs:{"own-consultant":_vm.consultant_id,"can-review-fiscal-obligations":_vm.can_review_fiscal_obligations}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }